"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEditorTableSearch = void 0;
const react_1 = __importDefault(require("react"));
const search_styles_1 = require("./search.styles");
const localization_1 = require("../../../../localization");
const selectors_1 = require("../../../../store/selectors");
const ProductEditorTableSearch = ({ searchQuery, onSearch }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const total = (0, selectors_1.useProductsTotal)();
    const handleSearch = (e) => {
        var _a;
        const query = (_a = e.currentTarget.value) !== null && _a !== void 0 ? _a : '';
        onSearch(query);
    };
    const handleClear = () => {
        onSearch('');
    };
    return (react_1.default.createElement(search_styles_1.StyledSearchInput, { placeholder: t({ key: 'SEARCH' }), searchInputValue: searchQuery, numberOfResultsLabel: t({
            key: 'SEARCH_INPUT_RESULTS_LABEL',
            values: { numberOfResults: total, modelType: t({ key: 'PRODUCT_EDITOR_TABLE_ITEMS_NAME' }) },
        }), handleInputChange: handleSearch, handleInputClear: handleClear }));
};
exports.ProductEditorTableSearch = ProductEditorTableSearch;
exports.default = exports.ProductEditorTableSearch;
